import { Component, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';
import { ParentViewportService } from '../../../core/services/parent-viewport.service';

@Component({
  selector: 'app-alert-dialog',
  imports: [],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
})
export class AlertDialogComponent {
  @Input() title = '';
  @Input() message = '';
  @Input() description = '';
  @Input() confirmLabel = 'Confirmar';
  @Input() cancelLabel = 'Cancelar';
  /** Exibe ou oculta o ícone (seta) no botão principal. */
  @Input() showConfirmIcon = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  /**
   * Dentro do portal a viewport do iframe é a página inteira; centralizar nela
   * pode jogar o diálogo para fora da tela. A caixa se centraliza na faixa que o
   * usuário está vendo, e acompanha o scroll do portal enquanto está aberta.
   */
  protected readonly regiaoVisivel = inject(ParentViewportService).regiaoVisivel;

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onCancel();
  }
}

